import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from 'app'

import initializeEssentials from 'utils/essentials'

import 'styles/index.scss'

initializeEssentials()

let container = document.getElementById('root')
if (!container) {
    container = document.createElement('div')
    container.setAttribute('id', 'root')
    document.body.appendChild(container)
}
const root = createRoot(container) // createRoot(container!) if you use TypeScript

root.render(
    <StrictMode>
        <App />
    </StrictMode>,
)
